module.exports = __webpack_public_path__ + "img/1561934779.83a72324.jpg";